<label class="switch__label" for="field.key">
  <ui-switch color="#3dcb35" switchColor="#fff" [formControl]="control" [id]="field.key"></ui-switch>
  <div class="switch__label__text" [ngClass]="{'switch__label__text--true': isSwitchOn()}">{{ getSwitchLabel()
    }}</div>
</label>